module.exports = __webpack_public_path__ + "img/retrospect-inspect-portrait.49b028d5.jpg";